import { styled } from "../../../styles";

/** The stored key prefix — the only part of the value we ever keep. */
export const KeyPrefix = styled("code", {
  fontFamily: "monospace",
  fontSize: "13px",
  color: "$charcoal",
});

export const ChipList = styled("div", {
  display: "flex",
  flexWrap: "wrap",
  gap: "4px",
});

export const ClaimChip = styled("span", {
  display: "inline-flex",
  alignItems: "center",
  padding: "2px 8px",
  borderRadius: "12px",
  border: "1px solid $gray-30",
  backgroundColor: "$white",
  fontSize: "12px",
  lineHeight: "16px",
  color: "$gray-80",
  whiteSpace: "nowrap",
});

/** The checklist of assignable claims in the create/edit modal. */
export const ClaimsList = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  maxHeight: "40vh",
  overflow: "auto",
  padding: "4px 0",
});

export const ClaimDescription = styled("span", {
  display: "block",
  fontSize: "12px",
  lineHeight: "16px",
  color: "$gray-80",
  marginLeft: "24px",
});

/** The freshly minted plain key, shown once. */
export const KeyPanel = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "12px",
});

export const KeyRow = styled("div", {
  display: "flex",
  alignItems: "center",
  gap: "8px",
});

export const KeyValue = styled("input", {
  flex: 1,
  height: "40px",
  padding: "0 12px",
  borderRadius: "6px",
  border: "1px solid $gray-40",
  backgroundColor: "$gray-20",
  fontFamily: "monospace",
  fontSize: "13px",
  color: "$charcoal",
});

export const CopyKeyButton = styled("button", {
  height: "40px",
  padding: "0 16px",
  borderRadius: "6px",
  border: "1px solid $gray-40",
  backgroundColor: "$white",
  color: "$charcoal",
  fontSize: "13px",
  fontFamily: "$openSans",
  cursor: "pointer",
  whiteSpace: "nowrap",

  "&:hover": {
    backgroundColor: "$gray-20",
  },

  variants: {
    copied: {
      true: {
        borderColor: "$success",
        color: "$success-dark",
      },
    },
  },
});

export const ExpiryCell = styled("span", {
  display: "inline-flex",
  alignItems: "center",
  gap: "8px",
});
